import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

function querystring(name: string, url = window.location.href) {
  name = name.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)', 'i');
  const results = regex.exec(url);

  if (!results) {
    return null;
  }
  if (!results[2]) {
    return '';
  }

  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

interface IProps {
  isAuthenticated?: boolean;
  children: React.ReactNode;
  [x: string]: any;
}

const UnauthenticatedRoute = ({ isAuthenticated, children, ...rest }: IProps) => {
  const location = useLocation();
  const redirect = querystring('redirect');

  if (isAuthenticated) {
    return <Navigate to={redirect === '' || redirect === null ? '/' : redirect} replace />;
  }

  return <>{React.cloneElement(children as React.ReactElement, rest)}</>;
};

export default UnauthenticatedRoute;
